<template>
  <FeeScheduleItemLayout
    :section-classes="[$style['fee-schedule-item']]"
    :header-classes="[$style['title-row']]"
    :title-classes="[$style['title-left']]"
    :action-ct-classes="[$style['action-buttons-container']]"
  >
    <template #title>
      <div :class="$style['title-text']">
        {{
          schedule.name
            ? schedule.name
            : !schedule.isMaxFee
            ? translate('newFeeSchedule')
            : translate('newMaxFee')
        }}
      </div>
    </template>
    <template #action>
      <mds-button type="button" variation="secondary" @click="handleCancel">
        {{ translate('cancel') }}
      </mds-button>
      <mds-button type="button" variation="primary" @click="handleSave">
        {{ translate('save') }}
      </mds-button>
    </template>
    <EditFeeScheduleView
      ref="editFeeScheduleView"
      :mwc-id="getMwcIdForChild('edit-fee-schedule-view')"
      :prop-schedule="schedule"
      :fee-schedule-types="feeScheduleTypes"
      :show-info-icons="showInfoIcons"
      :is-program-based-mode="isProgramBasedMode"
      :program-options="programOptions"
    />
  </FeeScheduleItemLayout>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import { MdsButton } from '@mds/button';
import EditFeeScheduleView from './EditFeeScheduleView';
import FeeScheduleItemLayout from './common/layout/FeeScheduleItemLayout';

export default {
  name: 'fee-schedule-item-editor',
  components: {
    MdsButton,
    FeeScheduleItemLayout,
    EditFeeScheduleView,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    schedule: {
      type: Object,
      default: () => {},
    },
    feeScheduleTypes: {
      type: Array,
      default: () => [],
    },
    showInfoIcons: {
      type: Boolean,
      default: true,
    },
    isProgramBasedMode: Boolean,
    programOptions: Array,
  },
  data() {
    return {
      name: this.schedule.name,
    };
  },
  methods: {
    handleCancel() {
      this.$emit('item-cancel-clicked');
    },
    handleSave() {
      this.$refs.editFeeScheduleView.validateInput().then(valid => {
        if (valid) {
          this.$emit('item-save-clicked', this.$refs.editFeeScheduleView.emitData());
        }
      });
    },
  },
};
</script>

<style lang="scss" module>
@import './styles/fee-schedule-item.scss';
</style>
